import { initializeApp, getApps } from 'firebase/app';
import { connectAuthEmulator, getAuth } from 'firebase/auth';
// import { connectFirestoreEmulator, initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from 'firebase/firestore';
// import { getStorage, connectStorageEmulator } from 'firebase/storage';
// GA analytics intentionally NOT initialized — observability is Sentry-only (2026-09-14 decision);
// this keeps @firebase/analytics + @firebase/installations out of the entry bundle.


const firebaseConfig = {
    apiKey: import.meta.env.VITE_TFP_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_TFP_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_TFP_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_TFP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_TFP_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_TFP_FIREBASE_APP_ID,
    measurementId: import.meta.env.VITE_TFP_FIREBASE_MEASUREMENT_ID,
};


// Initialize Firebase only once
const firebaseApp = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);

// Export initialized instances
export const auth = getAuth(firebaseApp);

if (import.meta.env.MODE === 'development') {
    connectAuthEmulator(auth, import.meta.env.VITE_TFP_AUTH_EMULATOR);
}

// export const db = initializeFirestore(firebaseApp, {
//     localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager()})
// });

// if (import.meta.env.MODE === 'development') {
//     connectFirestoreEmulator(db, import.meta.env.VITE_TFP_EMULATOR_FIRESTORE_HOST, Number(import.meta.env.VITE_TFP_EMULATOR_FIRESTORE_PORT));
// }

// export const storage = getStorage(firebaseApp);

// if (import.meta.env.MODE === 'development') {
//     connectStorageEmulator(storage, import.meta.env.VITE_TFP_EMULATOR_FIRESTORE_HOST, Number(import.meta.env.VITE_TFP_EMULATOR_STORAGE_PORT));
// }

export default firebaseApp; // Export the app instance itself if needed
